import './app';
import './googleAnalyticsService';

export default '7Shop.GoogleAnalytics';
